<div class="td-wb-image-placeholder" [style.paddingTop.%]="heightPercentage">
  <div class="td-wb-image-placeholder__image">
    <ng-content />
  </div>
</div>